import React from 'react'
import type { StartLabelFilterStackProps } from '@edge/spark/feature-mui-rhf-inputs'
import { StartLabelFilterStack } from '@edge/spark/feature-mui-rhf-inputs'

export const FilterField: React.VFC<StartLabelFilterStackProps> = ({
    selectProps,
    textFieldProps,
    ...restProps
}: StartLabelFilterStackProps) => {
    return (
        <StartLabelFilterStack
            selectProps={{
                sx: { minWidth: 0.4 },
                fullWidth: true,
                variant: 'standard',
                ...selectProps,
            }}
            textFieldProps={{
                fullWidth: true,
                variant: 'standard',
                ...textFieldProps,
            }}
            {...restProps}
        />
    )
}
